import GeoContext from 'contexts/geoContext'
import { useContext } from 'react'

const contact: App.GeoContact = {
  humanReadable: '1300 860 454',
  number: '1300860454',
}

function useContact(): App.GeoContact {
  const { currentRegionCode, currentContact } = useContext(GeoContext)

  if (currentRegionCode === 'AU') {
    return contact
  }
  return currentContact[currentContact.default]
}

export default useContact
